import {GetSeferData} from "SeferPetach/GetData";

export async function getHomeData() {
    var payload = await GetSeferData("utl1", {});
    return (payload);
}